import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import BasicSwitches from './BasicSwitches';
import ClientProvider from './client';
export default createDemo(import.meta.url, BasicSwitches, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/switches/demos/basic/BasicSwitches.tsx",
    "fileName": "BasicSwitches.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Switch from '@mui/material/Switch';\n\nconst label = { slotProps: { input: { 'aria-label': 'Switch demo' } } };\n\nexport default function BasicSwitches() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Switch {...label} defaultChecked />\n      <Switch {...label} />\n      <Switch {...label} disabled defaultChecked />\n      <Switch {...label} disabled />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 14,
        "focusedLines": 4,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Switch from '@mui/material/Switch';\n\nconst label = { slotProps: { input: { 'aria-label': 'Switch demo' } } };\n\nexport default function BasicSwitches() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Switch {...label} defaultChecked />\n      <Switch {...label} />\n      <Switch {...label} disabled defaultChecked />\n      <Switch {...label} disabled />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 8
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 9
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 10
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 11
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Switch"
              ],
              " ",
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-k di-pu",
                "..."
              ],
              [
                "span",
                "pl-smi di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 14,
    "focusedLines": 4,
    "collapsible": true,
    "externals": [
      "@mui/material/Switch"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
